<template>
  <v-app id="inspire">
    <!-- Sidebar Event -->
    <v-navigation-drawer v-model="drawer" app width="300">
      <!-- Mini Variant Sidebar -->
      <v-navigation-drawer
        v-model="drawer"
        absolute
        color="grey lighten-3"
        mini-variant
      >
        <!-- <v-avatar class="d-block text-center mx-auto mt-4" size="40"> -->
        <v-img
          alt="DJ"
          class="shrink mt-1 hidden-sm-and-down d-block text-center mx-auto mt-4"
          contain
          max-width="50"
          :src="require('../../assets/logo.png')"
        />
        <!-- </v-avatar> -->

        <v-divider class="mx-3 my-5"></v-divider>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              class="d-block text-center mx-auto mb-9"
              color="orange lighten-1"
              size="28"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-view-dashboard </v-icon>
            </v-avatar>
          </template>
          <span>Dashboard</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              class="d-block text-center mx-auto mb-9"
              color="indigo lighten-1"
              size="28"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-console-network </v-icon>
            </v-avatar>
          </template>
          <span>Work Book</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <router-link to="users" style="text-decoration: none">
              <v-avatar
                class="d-block text-center mx-auto mb-9"
                v-bind="attrs"
                v-on="on"
                color="green lighten-1"
                size="28"
              >
                <v-icon size="23" dark> mdi-account</v-icon>
              </v-avatar>
            </router-link>
          </template>
          <span>Users</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <router-link to="values" style="text-decoration: none">
              <v-avatar
                class="d-block text-center mx-auto mb-9"
                v-bind="attrs"
                v-on="on"
                color="blue lighten-1"
                size="28"
              >
                <v-icon size="23" dark> mdi-format-list-text</v-icon>
              </v-avatar>
            </router-link>
          </template>
          <span>Values</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <router-link to="value-lists" style="text-decoration: none">
              <v-avatar
                class="d-block text-center mx-auto mb-9"
                v-bind="attrs"
                v-on="on"
                color="red lighten-1"
                size="28"
              >
                <v-icon size="23" dark> mdi-format-list-bulleted-square</v-icon>
              </v-avatar>
            </router-link>
          </template>
          <span>ValueLists</span>
        </v-tooltip>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <router-link to="events" style="text-decoration: none">
              <v-avatar
                class="d-block text-center mx-auto mb-9"
                v-bind="attrs"
                v-on="on"
                color="indigo lighten-1"
                size="28"
              >
                <v-icon size="23" dark> mdi-calendar-star</v-icon>
              </v-avatar>
            </router-link>
          </template>
          <span>Events</span>
        </v-tooltip>
      </v-navigation-drawer>
      <!-- / Mini Variant Sidebar -->

      <v-sheet color="grey lighten-5" height="50" width="100%"> </v-sheet>

      <!-- Main Sidebar -->
      <v-list class="pl-14" shaped>
        <!-- Search bar for listing -->
        <v-responsive class="ml-2">
          <v-row class="mb-1">
            <v-col md="9" class="pr-0">
              <v-text-field
                dense
                flat
                hide-details
                rounded
                solo-inverted
                v-model="search_keyword"
                @input="getBoards()"
              ></v-text-field>
            </v-col>
            <v-col md="3">
              <v-menu
                v-if="userPermissions.find((up) => up == 'CREATE_BOARD')"
                :offset-x="true"
                transition="slide-x-transition"
                bottom
                right
              >
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        color="primary"
                        fab
                        class="mt-1"
                        outlined
                        x-small
                        dark
                        v-bind="attrs"
                        v-on="{ ...tooltip, ...menu }"
                      >
                        <v-icon dark> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Add Item to Workspace</span>
                  </v-tooltip>
                </template>

                <v-list nav dense>
                  <v-list-item-group>
                    <v-list-item class="px-2" @click="is_save_baord = true">
                      <v-list-item-icon class="mx-1">
                        <v-icon size="20">mdi-developer-board</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>New Board</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item dense class="px-2">
                      <v-list-item-icon class="mx-1">
                        <v-icon size="20">mdi-eye</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>New Doc</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-responsive>
        <!-- / Search bar for listing -->
        <v-progress-linear
          indeterminate
          :size="15"
          v-if="isLoading"
          class="ml-1 my-auto"
          color="primary"
        ></v-progress-linear>
        <v-list-item-group v-else>
          <!-- Board Listing -->
          <v-list-item
            v-for="board in boards"
            :key="`board${board.id}`"
            @click="getEvents(`${board.id}`)"
            active-class="true"
          >
            <!-- active-class="form.id == board.id ? `true` : `false`" -->
            <!-- List Icon & Tooltip for Icon -->
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon class="mx-1" v-bind="attrs" v-on="on">
                  <v-icon size="20">mdi-developer-board</v-icon>
                </v-list-item-icon>
              </template>
              <span
                >{{ form.id }} This board is public, Visible to all team
                members.</span
              >
            </v-tooltip>
            <!-- / List Icon & Tooltip for Icon -->
            <v-list-item-content>
              <!-- List Item & Tooltip For item -->
              <div v-if="board.is_editor_on == `true`">
                <v-text-field
                  v-model="board.name"
                  outlined
                  dense
                  @key.enter="update_board(board)"
                >
                </v-text-field>
              </div>
              <div v-else>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-title v-bind="attrs" v-on="on">
                      {{ board.name }}
                    </v-list-item-title>
                  </template>
                  <span>{{ board.name }}</span>
                </v-tooltip>
              </div>
              <!-- / List Item & Tooltip For item -->
            </v-list-item-content>
            <v-list-item-action>
              <v-menu
                :offset-x="true"
                transition="slide-x-transition"
                bottom
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    class="mt-1"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark> mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>

                <v-list nav dense>
                  <v-list-item-group>
                    <v-list-item
                      class="px-2"
                      target="_blank"
                      :to="`/home/${board.id}`"
                    >
                      <v-list-item-icon class="mx-1">
                        <v-icon size="20">mdi-open-in-new</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          >Open Board in New Tab
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="userPermissions.find((up) => up == 'EDIT_BOARD')"
                      dense
                      class="px-2"
                      @click="edit_board(`${board.id}`)"
                    >
                      <v-list-item-icon class="mx-1">
                        <v-icon size="20">mdi-pencil-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Rename</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="userPermissions.find((up) => up == 'DELETE_BOARD')"
                      dense
                      class="px-2"
                      @click="delete_data(`${board.id}`, 'boards')"
                    >
                      <v-list-item-icon class="mx-1">
                        <v-icon size="20">mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>
          <!-- / Board Listing -->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <!--  -->
      <v-toolbar v-if="form.id">
        <v-toolbar-title>
          {{ form.name }}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="SendBoardSummary(form.id)"
                icon
                :loading="isSendingBoardSummary"
                ><v-icon>mdi-email</v-icon></v-btn
              >
            </template>
            <span>Send Board Summary</span>
          </v-tooltip>
        </v-toolbar-title>
      </v-toolbar>
      <v-progress-linear
        v-if="isEventLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <events v-if="form.id" class="pa-5" :form="form" :userItems="userItems">
      </events>
    </v-main>

    <v-footer app color="transparent" height="72" inset> </v-footer>
    <!-- Create Board Pop UP  -->
    <v-dialog v-model="is_save_baord" max-width="500px">
      <v-card elevation="2">
        <v-card-title>
          <span>
            <h2>
              {{ is_update_baord == true ? "Update Board" : "Create Board" }}
            </h2>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="is_save_baord = false">
            <v-icon>mdi-window-close </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-5">
          <v-row>
            <v-col sm="12">
              <v-text-field
                v-model="board.name"
                outlined
                dense
                label="Board Name"
                prepend-inner-icon="mdi-developer-board"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                ref="vessel"
                v-model="board.vessels"
                :items="vesselItems"
                label="Select Vessel"
                outlined
                small-chips
                multiple
                dense
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                ref="department"
                :hint="
                  !is_select_all_department
                    ? 'Click the checkbox to select all department'
                    : 'Click the checkbox to unselect all department'
                "
                persistent-hint
                v-model="board.departments"
                :items="departmentItems"
                label="Select Department"
                outlined
                small-chips
                multiple
                dense
              >
                <template v-slot:append-outer>
                  <v-slide-x-reverse-transition mode="out-in">
                    <v-checkbox
                      class="mt-0"
                      @click="selectAllDepartment(board)"
                      v-model="is_select_all_department"
                    ></v-checkbox>
                  </v-slide-x-reverse-transition>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <v-datetime-picker
                label="Select Start Date & Time"
                v-model="board.start_date"
              >
              </v-datetime-picker>
            </v-col>
            <v-col sm="6">
              <v-datetime-picker
                label="Select End Date & Time"
                v-model="board.end_date"
              >
              </v-datetime-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="userPermissions.find((up) => up == 'ADD_PARTICIPANT')">
              <v-autocomplete
                class="mt-2"
                v-model="board.participants"
                :items="userItems"
                chips
                outlined
                dense
                color="blue-grey lighten-2"
                label="Select Participants"
                item-text="name"
                item-value="value"
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove_participant(data.item, board)"
                  >
                    {{ data.item.initials }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.name"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-select
                v-model="board.status"
                :items="BoardStatusItems"
                chips
                outlined
                item-color="red"
                label="Status"
                class="mt-2"
                dense
              >
                <template v-slot:selection="{ item }">
                  <v-chip dark v-if="item.text == 'PENDING'" color="gray">{{
                    item.text
                  }}</v-chip>
                  <v-chip dark v-if="item.text == 'COMPLETED'" color="green">{{
                    item.text
                  }}</v-chip>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn text class="mr-2" @click="is_save_baord = false"
              >Close
            </v-btn>
            <v-btn
              color="primary"
              @click="save_board"
              :loading="isSavingBoard"
              :disabled="isSavingBoard"
              >{{ is_update_baord == true ? "Update Board" : "Create Board" }}
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- / Create Board Pop UP -->
  </v-app>
</template>

<script>
import axios from "axios";
import events from "./events.vue";
// import moment from "moment";

export default {
  components: { events },
  data() {
    return {
      form: {
        events: [],
      },
      board: {
        name: "",
        start_date: new Date(),
        end_date: new Date(),
        vessels: [],
        board_vessels: [],
        departments: [],
        board_departments: [],
        participants: [],
        board_participants: [],
      },
      search_keyword: "",
      boards: [],
      users: [],
      userItems: [],
      vesselItems: [],
      departmentItems: [],
      BoardStatusItems: [
        { id: "0", text: "PENDING", value: 0 },
        { id: "1", text: "COMPLETED", value: 1 },
      ],
      is_save_baord: false,
      is_update_baord: false,
      isSavingBoard: false,
      isEventLoading: false,
      isSendingBoardSummary: false,
      is_select_all_department: false,
      isLoading: false,
      drawer: null,
    };
  },
  mounted() {
    this.getBoards();
    this.getUsers();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("boards/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vesselItems.push({
          id: vessel.id,
          text: vessel.description,
          value: vessel.id,
        });
      });
      masters.departments.forEach((department) => {
        this.departmentItems.push({
          id: department.id,
          text: department.description,
          value: department.id,
        });
      });
    },
    remove_participant(item, board) {
      // remove Participant from Array
      const index = board.participants.indexOf(item.id);
      if (index >= 0) board.participants.splice(index, 1);
    },
    async getUsers() {
      this.isUserLoading = true;
      let users = await axios.get(`users`);
      this.users = users.data.data;
      this.users.forEach((user) => {
        let ui = {
          id: user.id,
          name: user.first_name + " " + user.last_name,
          value: user.id,
          // initials: user.first_name.charAt(0),
          initials: user.first_name.charAt(0) + "" + user.last_name?.charAt(0),
        };
        this.userItems.push(ui);
      });
      this.isUserLoading = false;
    },
    async getBoards() {
      this.boards = [];
      this.isLoading = true;
      let boards = [];
      let query = "search_keyword=" + this.search_keyword;
      boards = await axios.get(`boards?${query}`);
      this.boards = boards.data.data;
      this.isLoading = false;
    },
    async getEvents(board_id) {
      this.form = [];
      this.isEventLoading = true;
      let form = await axios.get(`boards/${board_id}`);
      this.form = form.data.data;
      this.form.events.forEach((event) => {
        event.Attendees = [];
        event.event_attendees.forEach((e) => {
          event.Attendees.push(e.attendee_id);
        });
        event.tasks.forEach((task) => {
          task.Assignees = [];
          task.task_assignees.forEach((ta) => {
            task.Assignees.push(ta.assignee_id);
          });
        });
      });
      this.isEventLoading = false;
    },
    async save_board() {
      try {
        this.isSavingBoard = true;
        let board_vessels = [];
        console.log(this.board.start_date);
        this.board.vessels.forEach((vessel_id) => {
          let boardVessel = this.board.board_vessels.find(
            (g) => g.vessel_id == vessel_id
          );
          if (boardVessel) {
            board_vessels.push(boardVessel);
          } else {
            let board_vessel = {
              vessel_id: vessel_id,
            };
            board_vessels.push(board_vessel);
          }
        });
        this.board.board_vessels = board_vessels;
        let board_departments = [];
        this.board.departments.forEach((department_id) => {
          let boardVessel = this.board.board_departments.find(
            (g) => g.department_id == department_id
          );
          if (boardVessel) {
            board_departments.push(boardVessel);
          } else {
            let board_department = {
              department_id: department_id,
            };
            board_departments.push(board_department);
          }
        });
        this.board.board_departments = board_departments;
        let board_participants = [];
        this.board.participants.forEach((participant_id) => {
          let boardVessel = this.board.board_participants.find(
            (g) => g.participant_id == participant_id
          );
          if (boardVessel) {
            board_participants.push(boardVessel);
          } else {
            let board_participant = {
              participant_id: participant_id,
            };
            board_participants.push(board_participant);
          }
        });
        this.board.board_participants = board_participants;
        await axios.post("/boards", this.board);
        this.isSavingBoard = false;
        this.getBoards();
        this.is_save_baord = false;
        this.is_update_baord = false;
        this.board = {
          name: "",
        };
      } catch (e) {
        console.log(e);
        this.isSavingBoard = false;
      }
    },
    edit_board(id) {
      this.board = this.boards.find((b) => b.id == id);
      this.is_update_baord = true;
      let vessels = [];
      if (this.board.board_vessels) {
        this.board.board_vessels.forEach((vessel) => {
          vessels.push(vessel.vessel_id);
        });
      }
      this.board.vessels = vessels;
      let departments = [];
      if (this.board.board_departments) {
        this.board.board_departments.forEach((department) => {
          departments.push(department.department_id);
        });
      }
      this.board.departments = departments;
      let participants = [];
      if (this.board.board_participants) {
        this.board.board_participants.forEach((participant) => {
          participants.push(participant.participant_id);
        });
      }
      this.board.participants = participants;
      this.is_save_baord = true;
      console.log(this.board);
    },
    async delete_data(id, table_name) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=${table_name}`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
        switch (table_name) {
          case "boards":
            this.getBoards();
            break;

          default:
            break;
        }
      }
    },
    async SendBoardSummary(id) {
      this.isSendingBoardSummary = true;
      await axios.post(`/boards/send_summary?board_id=${id}`);
      this.isSendingBoardSummary = false;
    },
    selectAllDepartment(board) {
      if (this.is_select_all_department == true) {
        console.log(this.departmentItems);
        this.departmentItems.forEach((department) => {
          let department_details = board.departments.find(
            (d) => d == department.id
          );
          if (!department_details) {
            board.departments.push(department.id);
          }
        });
      } else {
        board.departments = [];
      }
    },
  },
};
</script>
